import { stateCity, activities, unity, stores } from '../../modules/select';
import { dateRange } from '../../modules/dateRange';
import { userSubscribe } from '../../modules/userSubscribe';
import { _filter } from './_filter';

export const challengesIndex = () => {
  stateCity();
  activities();
  unity();
  stores();
  dateRange('up');
  userSubscribe();
  _filter();
};
